import { Auth } from 'aws-amplify';
import Axios from 'axios';

import { ADVENTURES_MANAGER } from '../apis';

const generateConfig = (jwtToken, apiToken) => {
	console.log('jwtToken', jwtToken);
	return {
		headers: {
			Accept: '*/*',
			Authorization: jwtToken,
			'content-type': '',
			'X-API-KEY': apiToken,
		},
		timeout: 10000,
	};
};

const adventureApis = ADVENTURES_MANAGER[process.env.REACT_APP_API_ENV];

export const getAllAdventures = async () => {
	const currentSession = await Auth.currentSession();
	const config = generateConfig(currentSession.getIdToken().getJwtToken(), adventureApis.token);
	console.log('adventures config', config);

	try {
		console.log('adventures url', adventureApis.urls.getAdventures);
		const response = await Axios.post(
			adventureApis.urls.getAdventures,
			{
				size: 10,
			},
			config
		);
		return JSON.parse(response.data.body).data.adventures.Items;
	} catch (e) {
		console.log('error getting all adventures', e);
		return null;
	}
};

export const createAdventure = async (adventure) => {
	const currentSession = await Auth.currentSession();
	const config = generateConfig(currentSession.getIdToken().getJwtToken(), adventureApis.token);

	if (adventure.owner === null) {
		const currentUserInfo = await Auth.currentUserInfo();
		adventure.owner = currentUserInfo.username;
	}

	if (adventure.masters.length === 0) {
		const currentUserInfo = await Auth.currentUserInfo();
		adventure.masters = [currentUserInfo.username];
	}
	const response = await Axios.post(adventureApis.urls.createAdventure, adventure, config);
	if (response.data.statusCode === 200) {
		return JSON.parse(response.data.body).data.adventure;
	} else {
		console.error('error creating adventure', JSON.parse(response.data.body));
		throw new Error(`error creating adventure`);
	}
};

export const updateAdventure = async (adventure) => {
	const currentSession = await Auth.currentSession();
	const config = generateConfig(currentSession.getIdToken().getJwtToken(), adventureApis.token);

	if (adventure.owner === null) {
		const currentUserInfo = await Auth.currentUserInfo();
		adventure.owner = currentUserInfo.username;
	}

	if (adventure.masters.length === 0) {
		const currentUserInfo = await Auth.currentUserInfo();
		adventure.masters = [currentUserInfo.username];
	}

	if (!adventure.ID) {
		throw new Error("No adventure ID in ", adventure);
	}

	const response = await Axios.patch(adventureApis.urls.updateAdventure(adventure.ID), adventure, config);
	if (response.data.statusCode === 200) {
		return JSON.parse(response.data.body).data.adventure;
	} else {
		console.error('error creating adventure', JSON.parse(response.data.body));
		throw new Error(`error creating adventure`);
	}
};

export const getAdventure = async (adventureId) => {
	const currentSession = await Auth.currentSession();
	const config = generateConfig(currentSession.getIdToken().getJwtToken(), adventureApis.token);

	try {
		const response = await Axios.get(adventureApis.urls.getAdventure(adventureId), config);
		return JSON.parse(response.data.body).data.adventure;
	} catch (e) {
		console.log('error getting adventure', e);
		throw new Error(`error getting adventure`);
	}
};

export const deleteAdventure = async (adventureId) => {
	const currentSession = await Auth.currentSession();
	const config = generateConfig(currentSession.getIdToken().getJwtToken(), adventureApis.token);

	try {
		const response = await Axios.delete(
			adventureApis.urls.deleteAdventure(adventureId),
			config
		);
		return JSON.parse(response.data.body).data;
	} catch (e) {
		console.log('error deleting adventure', e);
		throw new Error(`error deleting adventure`);
	}
};
